import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import I0 from "../../../../assets/images/I0.png";
import I1 from "../../../../assets/images/I1.png";
import I2 from "../../../../assets/images/I2.png";
import I3 from "../../../../assets/images/I3.png";
import I4 from "../../../../assets/images/I4.png";
import I5 from "../../../../assets/images/I5.png";
import I6 from "../../../../assets/images/I6.png";
import I7 from "../../../../assets/images/I7.png";
import I8 from "../../../../assets/images/I8.png";
import Logo from "../../../../assets/icons/Fameo-X-App-icon.png";
import axios from "../../../../components/Hooks/axios";
import Cookies from "js-cookie";
import { setUserObject, logOut } from "../../../../redux/slices/authSlice";
import styles from "./Interest.module.scss";
import searchIcon from "../../../../assets/images/search.png";

const ALL_INTERESTS = [
	{
		id: "sports",
		name: "Sports",
		icon: I1,
		subs: ["Cricket", "Football", "Gym"],
	},
	{
		id: "health",
		name: "Health",
		icon: I2,
		subs: ["Yoga", "Meditation", "Nutrition"],
	},
	{
		id: "fitness",
		name: "Fitness",
		icon: I3,
		subs: ["Workout", "Bodybuilding", "Crossfit"],
	},
	{
		id: "dance",
		name: "Dance",
		icon: I4,
		subs: ["Hip Hop", "Ballet", "Contemporary"],
	},
	{
		id: "food",
		name: "Food",
		icon: I5,
		subs: ["Veg", "Non-Veg", "Desserts"],
	},
	{
		id: "cars",
		name: "Cars",
		icon: I6,
		subs: ["Sports Cars", "SUV", "Electric"],
	},
	{
		id: "clothing",
		name: "Clothing",
		icon: I7,
		subs: ["Casual", "Formal", "Streetwear"],
	},
	{
		id: "fashion",
		name: "Fashion",
		icon: I8,
		subs: ["Men", "Women", "Luxury"],
	},
];

const Interest = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const reduxUserId = useSelector((state) => state.auth?.userId);
	const reduxUser = useSelector((state) => state.auth?.user);
	const safeParseCookie = (cookieName) => {
		try {
			const val = Cookies.get(cookieName);
			if (!val || val === "undefined" || val === "null") return "";
			return JSON.parse(val);
		} catch (e) {
			const val = Cookies.get(cookieName);
			return val && val !== "undefined" && val !== "null" ? val : "";
		}
	};
	const userId = reduxUserId || safeParseCookie("E_current_userId");
	const [selectedInterests, setSelectedInterests] = useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const [isMobile, setIsMobile] = useState(window.innerWidth < 427);
	const [flippedCard, setFlippedCard] = useState(null);

	useEffect(() => {
		const tokenCookie = Cookies.get("E_token");
		if (!userId || !tokenCookie || tokenCookie === "undefined" || tokenCookie === "null") {
			dispatch(logOut());
			navigate("/signup", { replace: true });
			return;
		}

		if (reduxUser && reduxUser.isVerified === false) {
			dispatch(logOut());
			navigate("/signup", { replace: true });
		}
	}, [userId, reduxUser, navigate, dispatch]);

	const handleFlip = (id) => {
		setFlippedCard((prev) => (prev === id ? null : id));
	};

	const choseInterest = (sub) => {
		if (selectedInterests.includes(sub)) {
			setSelectedInterests(selectedInterests.filter((item) => item !== sub));
		} else {
			setSelectedInterests((prev) => [...prev, sub]);
		}
	};

	const handelNext = () => {
		if (selectedInterests.length < 3) {
			return toast.warn("Please choose at least 3 interests");
		}

		const data = JSON.stringify({
			_id: userId,
			interestName: selectedInterests,
		});

		axios
			.post("/auth/addInterest", data, {
				headers: { "Content-Type": "application/json" },
			})
			.then(() => {
				// Refresh user object so guards allow navigation
				axios.get(`/auth/get-user-details/${userId}`).then(({ data }) => {
					dispatch(setUserObject(data));
				});

				axios
					.get(`/auth/profile/get-unique-name/${userId}`)
					.then(({ data }) => {
						navigate("/get-started", { state: data.GetstatedName });
					})
					.catch(({ response }) => console.log(response.data));
			})
			.catch(({ response }) => console.log(response));
	};

	useEffect(() => {
		const handleResize = () => setIsMobile(window.innerWidth < 427);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const filteredInterests = ALL_INTERESTS.filter(
		(item) =>
			item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
			item.subs.some((sub) =>
				sub.toLowerCase().includes(searchTerm.toLowerCase())
			)
	);

	return (
		<div className={styles.InterestContainer}>
			<div className={styles.Container1}>
				<img src={Logo} alt="logo" />
			</div>

			<div className={styles.Container2}>
				{isMobile ? (
					<div>
						<p>Choose your</p>
						<h1>Interest</h1>
						{selectedInterests.length > 0 && (
							<span
								style={{
									fontSize: "1.6rem",
									fontWeight: "700",
									color: "#cb5be7",
								}}
							>
								Selected: {selectedInterests.length}
							</span>
						)}
					</div>
				) : (
					<div>
						<h1>Choose Your Interest</h1>
						<p>
							Please select at least 3 interest, later you can add more
							<span
								style={{
									marginLeft: "10px",
									fontWeight: "700",
									color: "#cb5be7",
								}}
							>
								Selected: {selectedInterests.length}
							</span>
						</p>
					</div>
				)}
				<div className={styles.searchBar}>
					<div className={styles.searchInner}>
						<img src={searchIcon} alt="search" />
						<input
							type="text"
							placeholder="Search interests..."
							value={searchTerm}
							onChange={(e) => setSearchTerm(e.target.value)}
						/>
					</div>
				</div>
			</div>

			<div className={styles.Container3}>
				{filteredInterests.length > 0 ? (
					filteredInterests.map((item) => {
						const isFlipped = flippedCard === item.id;
						const selectedSubsInThisCard = item.subs.filter((sub) =>
							selectedInterests.includes(sub)
						);
						const hasSelected = selectedSubsInThisCard.length > 0;

						return (
							<div
								key={item.id}
								className={`${styles.flipCard} ${
									isFlipped ? styles.isFlipped : ""
								}`}
							>
								<div
									className={`${styles.flipCardInner} ${
										isFlipped ? styles.flipped : ""
									}`}
								>
									{/* FRONT */}
									<div
										className={`${styles.flipCardFront} ${
											hasSelected ? styles.activeCard : ""
										}`}
										onClick={() => handleFlip(item.id)}
									>
										{hasSelected && (
											<img className={styles.Check} src={I0} alt="check" />
										)}
										{selectedSubsInThisCard.length > 0 && (
											<span className={styles.badge}>
												{selectedSubsInThisCard.length} selected
											</span>
										)}
										<img
											src={item.icon}
											alt={item.name}
											className={styles.cardImg}
										/>
										<h2>{item.name}</h2>
									</div>

									{/* BACK */}
									<div className={styles.flipCardBack}>
										<h3>{item.name}</h3>

										<div className={styles.subInterestList}>
											{item.subs.map((sub) => {
												const isSelected = selectedInterests.includes(sub);
												return (
													<div
														key={sub}
														className={`${styles.interestChip} ${
															isSelected ? styles.selectedChip : ""
														}`}
														onClick={(e) => {
															e.stopPropagation();
															choseInterest(sub);
														}}
													>
														{isSelected ? `✓ ${sub}` : sub}
													</div>
												);
											})}
										</div>

										<button
											className={styles.backBtn}
											type="button"
											onClick={(e) => {
												e.stopPropagation();
												setFlippedCard(null);
											}}
										>
											Back
										</button>
									</div>
								</div>
							</div>
						);
					})
				) : (
					<div className={styles.NoResults}>
						<h3>No interests found matching "{searchTerm}"</h3>
						<p>Try searching for something else like 'Sports' or 'Fashion'.</p>
					</div>
				)}
			</div>

			<div className={styles.Container4}>
				<button onClick={handelNext}>Next</button>
			</div>
		</div>
	);
};

export default Interest;
